export default __webpack_public_path__ + "static/media/toggle-menu.fb461076.svg";